import { Box } from '@spark-web/box';
import { Button } from '@spark-web/button';
import { XIcon } from '@spark-web/icon';
import { useTheme } from '@spark-web/theme';
import { FC, PropsWithChildren } from 'react';

type FilterChipProps = PropsWithChildren & {
  onRemove?: () => void;
};

const FilterChip: FC<FilterChipProps> = ({ children, onRemove }) => {
  const theme = useTheme();

  return (
    <Box
      border="neutral"
      borderRadius="full"
      display="flex"
      alignItems="center"
      justifyContent="spaceBetween"
      gap="large"
      paddingLeft="medium"
      paddingY="small"
      alignSelf="start"
      position="relative"
    >
      {children}
      <Button
        label="Close"
        tone="neutral"
        prominence="none"
        css={{
          background: 'none',
          borderRadius: theme.border.radius.full,
          right: theme.spacing.small,
          height: '12px',
          width: '12px',
        }}
        onClick={() => onRemove?.()}
      >
        <XIcon size="xxsmall" />
      </Button>
    </Box>
  );
};

export { FilterChip };
